module.exports = __webpack_public_path__ + "static/media/canete.9abc049b.webp";